class FaqNavigation extends HTMLElement {
    #scopeFromPassed = false;
    #scopeToReached = false;
    #intersectionObserver = new IntersectionObserver(this._onObserved.bind(this));

    constructor() {
        super();
    }

    connectedCallback() {
        this.faqLinkList = this.querySelector("#ds-faq-mobile-list");
        this.sidebarFaqList = this.querySelector("#ds-faq-list");
        this.showNavigationButton = this.querySelector("#ds-faq-filter");

        this.createNavigationLinks();

        this._scopeFrom = this;
        const newsletter = document.querySelector(".newsletter");
        if(newsletter){
            this._scopeTo = newsletter;
        }
        else{
            this._scopeTo = document.querySelector(".footer");
        }
        if (!this._scopeFrom || !this._scopeTo) {
            return;
        }
        this.#intersectionObserver.observe(this._scopeFrom);
        this.#intersectionObserver.observe(this._scopeTo);
    }
    disconnectedCallback() {
        this.#intersectionObserver.disconnect();
    }
    _onObserved(entries) {
        entries.forEach((entry) => {
            if (entry.target === this._scopeFrom) {
                this.#scopeFromPassed = entry.boundingClientRect.bottom < 0;
            }
            if (entry.target === this._scopeTo) {
                this.#scopeToReached = entry.isIntersecting;
            }
        });
        this.classList.toggle("is-visible", !this.#scopeToReached);
    }

    createNavigationLinks() {

        const faqLinks = document.querySelectorAll("h2[data-faq-link]");
        faqLinks.forEach(link => {
            //create new li element with anchor link
            const li = document.createElement("li");
            li.classList.add("rounded-sm");
            const anchor = document.createElement("a");
            anchor.setAttribute("href", "#" + link.getAttribute("data-faq-link"));
            anchor.textContent = link.getAttribute("data-faq-title");
            anchor.classList.add("bold");
            anchor.addEventListener("click", this._onNavigationClicked.bind(this));
            li.appendChild(anchor);
            const liClone = li.cloneNode(true);
            this.faqLinkList.appendChild(li);
            this.sidebarFaqList.appendChild(liClone);
        });
    }

    _onNavigationClicked(event) {
        event.preventDefault();
        const target = event.target.getAttribute("href");
        const element = document.querySelector(target);
        element.scrollIntoView({ behavior: "smooth" });
        document.querySelector("facet-drawer").hide();
        this.classList.toggle("menu-visible");
    }
}

if (!window.customElements.get("faq-navigation")) {
    customElements.define("faq-navigation", FaqNavigation);
}